module.exports = __webpack_public_path__ + "img/gomb-ref.261f5c28.png";